var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-table",
    {
      attrs: {
        data: _vm.tableData,
        "span-method": _vm.spanMethod,
        "header-align": "center",
        border: "",
      },
    },
    [
      _c("el-table-column", {
        attrs: {
          label: _vm.$t("sensory.calibration.user"),
          prop: "userName",
          "min-width": "300",
        },
      }),
      _c("el-table-column", {
        attrs: {
          label: _vm.$t("nav.plant"),
          prop: "plantName",
          "min-width": "300",
        },
      }),
      _c("el-table-column", {
        attrs: {
          label: _vm.$t("sensory.calibration.singleBatchScore"),
          prop: "singleBatchScore",
          "min-width": "300",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [_vm._v(_vm._s(scope.row.singleBatchScore) + "%")]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          label: _vm.$t("sensory.calibration.avgScore"),
          prop: "avgScore",
          "min-width": "300",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [_vm._v(_vm._s(scope.row.avgScore) + "%")]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          label: _vm.$t("sensory.calibration.passStatus"),
          prop: "passStatus",
          "min-width": "300",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }